/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Hero_LeadInputs */

const ja_playdata_home_hero_lead = /** @type {(inputs: Playdata_Home_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブストリーミング配信のデータに基づき、国内のメジャーなeスポーツ大会のイベントデータを幅広く保持しています。`)
};

const en_playdata_home_hero_lead = /** @type {(inputs: Playdata_Home_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our reports unlock deep insights for domestic Japanese esports and live game streams.`)
};

/**
* | output |
* | --- |
* | "Our reports unlock deep insights for domestic Japanese esports and live game streams." |
*
* @param {Playdata_Home_Hero_LeadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_hero_lead = /** @type {((inputs?: Playdata_Home_Hero_LeadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Hero_LeadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_hero_lead(inputs)
	return en_playdata_home_hero_lead(inputs)
});